/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
export default class TermsService extends Service {
    constructor(axios) {
        super(axios);
    }
    /** 현재 유효 약관 조회 */
    getTerms = async (termsType) => {
        const { data } = await this.get(apiWrapper.managerApi('/managements/mobiles/pro-apps/terms'), { termsType });
        return data;
    };
    /** 약관 목록 조회 */
    getTermsList = async (category) => {
        const { data } = await this.get(apiWrapper.managerApi('/managements/terms/list'), {
            categoryNm: category,
        });
        return data;
    };
    /** 약관 상세 조회 */
    getTermsDetail = async (termsId) => {
        const { data } = await this.get(apiWrapper.managerApi('/managements/terms'), {
            termsId,
        });
        return data;
    };
    /** 약관 생성 */
    registerTerms = async (termsInfo) => {
        const { data } = await this.post(apiWrapper.managerApi('/managements/terms'), termsInfo);
        return data;
    };
    /** 약관 수정 */
    updateTerms = async (termsId, termsInfo) => {
        const { data } = await this.post(apiWrapper.managerApi('/managements/terms/update'), {
            termsId,
            ...termsInfo,
        });
        return data;
    };
    /** 약관 삭제 */
    deleteTerms = async (termsId) => {
        const { data } = await this.delete(apiWrapper.managerApi('/managements/terms/delete'), undefined, {
            data: {
                termsId,
            },
        });
        return data;
    };
}
